import { gql } from '@apollo/client/core';

export const createCartCheckoutIntent = gql`
  mutation ($input: CartCheckoutInput!) {
    createCartCheckoutIntent(input: $input)
  }
`;

export const createCartWebIntent = gql`
  mutation ($input: CartCheckoutInput!) {
    createCartWebIntent(input: $input)
  }
`;

export const findFailedCheckoutOrders = gql`
  query ($search: String, $skip: Int, $take: Int) {
    findFailedCheckoutOrders(search: $search, skip: $skip, take: $take) {
      id
      createdAt
      updatedAt
      email
      firstName
      lastName
      phone
      buyerEntity
      buyerEntityId
      isAnonymousBuyer
      subtotal
      totalFee
      givingWalletCredit
      totalAmount
      intentId
      paymentConfirmed
      unfulfilledLineCount
      lines {
        id
        lineType
        stickerId
        stickerTitle
        quantity
        unitPrice
        donationCauseId
        donationAmount
        fulfilled
      }
    }
  }
`;

export const retryCheckoutOrder = gql`
  mutation ($checkoutOrderId: UUID!) {
    retryCheckoutOrder(checkoutOrderId: $checkoutOrderId)
  }
`;

export const findMyTickets = gql`
  query ($stickerId: UUID!, $orgId: String) {
    findMyTickets(stickerId: $stickerId, orgId: $orgId) {
      id
      code
      tierName
      selectedOption
      stickerId
      variantId
      section
      row
      seat
      checkedInAt
      createdAt
    }
  }
`;

export const findStickerRsvps = gql`
  query ($stickerId: UUID!) {
    findStickerRsvps(stickerId: $stickerId) {
      id
      code
      tierName
      selectedOption
      stickerId
      variantId
      section
      row
      seat
      checkedInAt
      createdAt
    }
  }
`;

export const checkInIssuedTicket = gql`
  mutation ($code: String!) {
    checkInIssuedTicket(code: $code)
  }
`;

export const findTicketAvailability = gql`
  query ($stickerId: UUID!) {
    findTicketAvailability(stickerId: $stickerId) {
      variantId
      title
      isAddOn
      capacity
      issued
      reserved
      remaining
      soldOut
    }
  }
`;

export const sendStickerAnnouncement = gql`
  mutation ($stickerId: UUID!, $subject: String!, $body: String!) {
    sendStickerAnnouncement(stickerId: $stickerId, subject: $subject, body: $body) {
      id
      stickerId
      subject
      body
      sentBy
      sentAt
      createdAt
    }
  }
`;

export const findStickerAnnouncements = gql`
  query ($stickerId: UUID!) {
    findStickerAnnouncements(stickerId: $stickerId) {
      id
      stickerId
      subject
      body
      sentBy
      sentAt
      createdAt
    }
  }
`;

export const askStickerHost = gql`
  mutation ($stickerId: UUID!, $question: String!, $email: String, $name: String) {
    askStickerHost(stickerId: $stickerId, question: $question, email: $email, name: $name) {
      id
      stickerId
      askerEntity
      askerEntityId
      askerEmail
      askerName
      question
      response
      answeredAt
      answeredBy
      createdAt
    }
  }
`;

export const respondToStickerQuestion = gql`
  mutation ($questionId: UUID!, $response: String!) {
    respondToStickerQuestion(questionId: $questionId, response: $response) {
      id
      stickerId
      askerEntity
      askerEntityId
      askerEmail
      askerName
      question
      response
      answeredAt
      answeredBy
      createdAt
    }
  }
`;

export const findStickerQuestions = gql`
  query ($stickerId: UUID!) {
    findStickerQuestions(stickerId: $stickerId) {
      id
      stickerId
      askerEntity
      askerEntityId
      askerEmail
      askerName
      question
      response
      answeredAt
      answeredBy
      createdAt
    }
  }
`;

export const resendTicketConfirmation = gql`
  mutation ($stickerId: UUID!, $orgId: String) {
    resendTicketConfirmation(stickerId: $stickerId, orgId: $orgId)
  }
`;

export const getTicketInsights = gql`
  query ($stickerId: UUID!) {
    getTicketInsights(stickerId: $stickerId) {
      totalAdmissions
      checkedInCount
      distinctBuyers
      grossRevenue
      totalRaised
      questionsTotal
      questionsUnanswered
      announcementsCount
      tiers {
        variantId
        title
        isAddOn
        capacity
        sold
        checkedIn
        revenue
      }
    }
  }
`;
